
<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">
    <v-nav-menu :navMenuItems="filteredNav" :title="getSystemSettings.systemName" :logo="getSystemSettings.logo"
      parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal :navbarType="navbarType" :logo="getSystemSettings.logo" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" :navMenuItems="filteredNav" />
      </template>

      <template v-else>
        <the-navbar-vertical :navbarColor="navbarColor" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6">

              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
// import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

import { helperMixin } from "../../mixin/helperMixin";

import { mapGetters } from "vuex";

export default {
  mixins: [helperMixin],
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: [
        {
          url: "/warehouseApproval",
          name: "Warehouse",
          icon: "TrelloIcon",
          slug: "Warehouse",
          i18n: "Warehouse",
          permissionName: "warehouseApproval"
        },
        {
          url: "/view/clients",
          name: "Clients",
          icon: "UserPlusIcon",
          slug: "Clients",
          i18n: "Clients",
          permissionName: "Clients"
        },

        // Grid  ArchiveIcon GridIcon FilterIcon

        {
          url: "/main",
          name: "Main",
          icon: "PieChartIcon",
          slug: "Main",
          i18n: "Main",
          permissionName: "Settings"
        },
        {
          url: "/stockoverview",
          name: "Stock Overview",
          icon: "EyeIcon",
          slug: "Main",
          i18n: "Main",
          permissionName: "Settings"
        },
        {
          url: "/stockmovement",
          name: "Stock Movement",
          icon: "PackageIcon",
          slug: "stockmovement",
          i18n: "stockmovement",
          permissionName: "Settings"
        },
        {
          url: "/inventory",
          name: "Inventory",
          icon: "ArchiveIcon",
          slug: "inventories",
          i18n: "inventories",
          permissionName: "Settings"
        },
        {
          url: "/gr",
          name: "Goods Received",
          icon: "LogInIcon",
          slug: "goodsReceived",
          i18n: "goodsReceived",
          permissionName: "Settings"
        },
        {
          url: "/gs",
          name: "Goods Sent Out",
          icon: "TruckIcon",
          slug: "goodsSentOut",
          i18n: "goodsSentOut",
          permissionName: "Settings"
        },
        {
          url: "/warehouse",
          name: "Warehouse",
          icon: "MapPinIcon",
          slug: "warehouse",
          i18n: "warehouse",
          permissionName: "Settings"
        },
        {
          header: "Reports",
          icon: "BarChartIcon",
          i18n: "ChartsAndMaps",
          permissionName: "Settings",
          items: [
            {
              url: "/stocktakes",
              name: "Stock Takes",
              icon: "DatabaseIcon",
              slug: "stocktakes",
              i18n: "stocktakes",
              permissionName: "System Settings"
            },
            {
              url: "/monthEndStockBalance",
              name: "Month End Stock Balance",
              icon: "ActivityIcon",
              slug: "monthEndStockBalance",
              i18n: "monthEndStockBalance",
              permissionName: "System Settings"
            },
            {
              url: "/stockCardSummary",
              name: "Stock Card Summary",
              icon: "GridIcon",
              slug: "stockCardSummary",
              i18n: "stockCardSummary",
              permissionName: "System Settings"
            },
            {
              url: "/miscell",
              name: "Miscell Report",
              icon: "DatabaseIcon",
              slug: "miscell",
              i18n: "miscell",
              permissionName: "System Settings"
            },
          ]
        },
        {
          header: "Settings",
          icon: "SettingsIcon",
          i18n: "ChartsAndMaps",
          permissionName: "Settings",
          items: [
            {
              url: "/view/warehouses",
              name: "Warehouse",
              icon: "DatabaseIcon",
              slug: "Warehouse",
              i18n: "Warehouse",
              permissionName: "System Settings"
            },
            {
              url: "/view/customers",
              name: "Customers",
              icon: "UsersIcon",
              slug: "customers",
              i18n: "customers",
              permissionName: "System Settings"
            },
            {
              url: "/view/suppliers",
              name: "Suppliers",
              icon: "TruckIcon",
              slug: "suppliers",
              i18n: "suppliers",
              permissionName: "System Settings"
            },
            {
              url: "/settings",
              name: "System Settings",
              icon: "SettingsIcon",
              slug: "settings",
              i18n: "Settings",
              permissionName: "System Settings"
            },

            {
              url: null,
              name: "Master Tables",
              icon: "GridIcon",
              tagColor: "success",
              i18n: "Charts",
              permissionName: "Master Tables",
              submenu: [
                {
                  url: "/view/companies",
                  name: "Companies",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "System Users"
                },
                {
                  url: "/view/locations",
                  name: "Location",
                  slug: "Location",
                  i18n: "Location",
                  permissionName: "System Users"
                },
                {
                  url: "/view/zones",
                  name: "Zone",
                  slug: "Zone",
                  i18n: "Zone",
                  permissionName: "System Users"
                },
                {
                  url: "/view/shelfs",
                  name: "Shelf",
                  slug: "Shelf",
                  i18n: "Shelf",
                  permissionName: "System Users"
                },
              ]
            },
            {
              url: null,
              name: "Users",
              icon: "UsersIcon",
              tagColor: "success",
              i18n: "Users",
              permissionName: "Master Tables",
              submenu: [
                {
                  url: "/view/users",
                  name: "System Users",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "System Users"
                },

                {
                  url: "/form/roles/role",
                  name: "User Roles",
                  slug: "usergroups",
                  i18n: "userGroups",
                  permissionName: "System Users"
                },

                {
                  url: "/view/pages",
                  name: "Pages",
                  slug: "pages",
                  i18n: "pages",
                  permissionName: "System Users"
                },

              ]
            },

          ]
        }
      ],

      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.main.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: "auth/getPermissions",
      getSystemSettings: "auth/getSystemSettings"
    }),
    filteredNav() {
      var menuItemCopy = this.navMenuItems;

      if (this.getPermissions != null) {
        var myPermission = this.getPermissions;
        var mainFilter = menuItemCopy.filter(f =>
          myPermission.includes(f.permissionName)
        );

        //filter sub menus
        mainFilter.forEach(element => {
          if (this.isset(element, "submenu")) {
            element.submenu = element.submenu.filter(f =>
              myPermission.includes(f.permissionName)
            );
          }

          if (this.isset(element, "items")) {
            element.items = element.items.filter(f =>
              myPermission.includes(f.permissionName)
            );

            element.items.forEach(el => {
              if (this.isset(el, "submenu")) {
                el.submenu = el.submenu.filter(f =>
                  myPermission.includes(f.permissionName)
                );
              }
            });
          }
        });

        return mainFilter;
      } else {
        this.$router.push("/pages/login").catch(() => { });
      }
    },
    bodyOverlay() {
      return this.$store.state.main.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.main.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.main.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.main.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.main.windowWidth;
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("main/updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    }
  },
  created() {
    //this.$store.dispatch("auth/getPermission");

    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.main.mainLayoutType);
  }
};
</script>

